document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('ach-lr-form');
  if (!form) return;

  const ENDPOINT = 'https://script.google.com/macros/s/XXXXXXXX/exec';

  function show(ok, msg) {
    alert(msg); // luego lo cambias por tu UI bonita
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const payload = Object.fromEntries(new FormData(form).entries());
    payload.url = location.href;
    payload.useragent = navigator.userAgent;

    try {
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        body: new URLSearchParams(payload)
      });

      const text = await res.text();

      if (text.startsWith('OK|')) {
        const code = text.split('|')[1];
        show(true, `¡Recibido! Código: ${code}`);
        form.reset();
      } else {
        show(false, text);
      }
    } catch (err) {
      show(false, 'No se pudo conectar. Reintenta en unos segundos.');
    }
  });
});

